define('responsive-gameday/views/Monitor/ViewModels/GamecenterViewModel',['require','exports','module','./ViewModelBase','GameDayCore','jquery','./distributors/PregameViewDistributor','./distributors/WrapupViewDistributor','./distributors/MatchupSummaryViewDistributor','./distributors/PanelTabsDistributor','./distributors/GameStateViewDistributor'],function(require,exports,module) {
    var ViewModelBase = require("./ViewModelBase"),
        GDC = require("GameDayCore"),
        $ = require("jquery"),
        PregameDist = require("./distributors/PregameViewDistributor"),
        WrapupDist = require("./distributors/WrapupViewDistributor"),
        MatchupSummaryDist = require("./distributors/MatchupSummaryViewDistributor"),
        PanelTabsDist = require("./distributors/PanelTabsDistributor"),
        GameStateDist = require("./distributors/GameStateViewDistributor");

    var Superclass;

    function GamecenterViewModel() {
        Superclass.constructor.call(this);
    }

    ViewModelBase.spawn(GamecenterViewModel).define({
        moldData: function(flavor) {
            GameStateDist.setGameData(GDC.getGameData());
            PanelTabsDist.setGameData(GDC.getGameData(), this.stateUpdates);
            PregameDist.setGameData(GDC.getGameData());
            WrapupDist.setGameData(GDC.getGameData());
            MatchupSummaryDist.setGameData(GDC.getGameData());
        }
    });

    Superclass = GamecenterViewModel.superclass;

    return GamecenterViewModel;
});
